/**
 * Jewelry Factory — homepage section interactions
 */
(function () {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initDepartments(root) {
    const deptList = root.querySelector('[data-jf-dept-list]');
    const deptPreview = root.querySelector('[data-jf-dept-preview]');
    if (!deptList || !deptPreview) return;

    const rows = deptList.querySelectorAll('.jf-dept');
    const imgs = deptPreview.querySelectorAll('img');

    const activate = (row) => {
      const i = parseInt(row.getAttribute('data-dept'), 10);
      rows.forEach((r) => r.classList.toggle('is-active', r === row));
      imgs.forEach((img, j) => img.classList.toggle('is-active', j === i));
    };

    rows.forEach((row) => {
      row.addEventListener('mouseenter', () => activate(row));
      row.addEventListener('focus', () => activate(row));
    });
  }

  function initShowcase(root) {
    const showTrack = root.querySelector('[data-jf-showcase-track]');
    if (!showTrack) return;

    const section = root;
    const viewport = root.querySelector('[data-jf-showcase-viewport]');
    const realItems = [...showTrack.querySelectorAll('.jf-showcase__item')];
    const N = realItems.length;
    if (!N || !viewport) return;

    const segs = [...root.querySelectorAll('.jf-showcase__seg')];
    const prevBtn = root.querySelector('[data-jf-showcase-prev]');
    const nextBtn = root.querySelector('[data-jf-showcase-next]');
    const copy = {
      flag: root.querySelector('[data-jf-showcase-flag]'),
      name: root.querySelector('[data-jf-showcase-name]'),
      meta: root.querySelector('[data-jf-showcase-meta]'),
      price: root.querySelector('[data-jf-showcase-price]'),
      cta: root.querySelector('[data-jf-showcase-cta]'),
    };

    const makeClone = (el) => {
      const c = el.cloneNode(true);
      c.classList.remove('is-active');
      c.setAttribute('aria-hidden', 'true');
      return c;
    };
    realItems.forEach((el) => showTrack.appendChild(makeClone(el)));
    [...realItems].reverse().forEach((el) => showTrack.insertBefore(makeClone(el), showTrack.firstChild));
    const items = [...showTrack.querySelectorAll('.jf-showcase__item')];

    const startLogical = Math.max(0, realItems.findIndex((el) => el.classList.contains('is-active')));
    let pos = N + startLogical;
    let switchTimer = null;
    let snapTimer = null;
    const logical = () => ((pos % N) + N) % N;

    const layout = () => {
      const item = items[pos];
      const gap = parseFloat(getComputedStyle(showTrack).gap) || 0;
      const w = item.offsetWidth;
      const x = viewport.clientWidth / 2 - w / 2 - pos * (w + gap);
      showTrack.style.transform = `translateX(${x}px)`;
    };

    const render = () => {
      items.forEach((el, j) => el.classList.toggle('is-active', j === pos));
      const li = logical();
      segs.forEach((s, j) => {
        s.classList.toggle('is-active', j === li);
        if (j === li) s.setAttribute('aria-selected', 'true');
        else s.removeAttribute('aria-selected');
      });
      layout();

      const d = items[pos].dataset;
      section.classList.add('is-switching');
      clearTimeout(switchTimer);
      switchTimer = setTimeout(() => {
        if (copy.flag) copy.flag.textContent = d.flag || '';
        if (copy.name) copy.name.textContent = d.name || '';
        if (copy.meta) copy.meta.textContent = d.meta || '';
        if (copy.price) copy.price.textContent = d.price || '';
        if (copy.cta) {
          copy.cta.textContent = d.cta || '';
          if (d.url) copy.cta.href = d.url;
        }
        section.classList.remove('is-switching');
      }, reduceMotion ? 0 : 220);
    };

    const snapIfNeeded = () => {
      clearTimeout(snapTimer);
      snapTimer = setTimeout(() => {
        if (pos < N || pos >= 2 * N) {
          pos = N + logical();
          showTrack.style.transition = 'none';
          items.forEach((el, j) => el.classList.toggle('is-active', j === pos));
          layout();
          void showTrack.offsetWidth;
          showTrack.style.transition = '';
        }
      }, reduceMotion ? 30 : 780);
    };

    const go = (p) => {
      pos = p;
      render();
      snapIfNeeded();
    };

    if (prevBtn) prevBtn.addEventListener('click', () => go(pos - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => go(pos + 1));
    items.forEach((el, j) =>
      el.addEventListener('click', () => {
        if (j !== pos) go(j);
      })
    );
    segs.forEach((s, j) => {
      s.addEventListener('click', () => {
        let delta = j - logical();
        if (delta > N / 2) delta -= N;
        if (delta < -N / 2) delta += N;
        go(pos + delta);
      });
    });

    let startX = null;
    viewport.addEventListener('pointerdown', (e) => (startX = e.clientX));
    viewport.addEventListener('pointerup', (e) => {
      if (startX === null) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 40) go(pos + (dx < 0 ? 1 : -1));
      startX = null;
    });

    section.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') go(pos - 1);
      if (e.key === 'ArrowRight') go(pos + 1);
    });

    window.addEventListener('resize', layout, { passive: true });
    window.addEventListener('load', layout);
    items.forEach((el, j) => el.classList.toggle('is-active', j === pos));
    render();
  }

  function initRails(root) {
    const rails = new Map();
    const hookRail = (btn, dir) => {
      const id = btn.getAttribute(dir === 'prev' ? 'data-jf-rail-prev' : 'data-jf-rail-next');
      const rail = root.querySelector(`#${id}`) || document.getElementById(id);
      if (!rail) return;
      if (!rails.has(rail)) rails.set(rail, {});
      rails.get(rail)[dir] = btn;
      btn.addEventListener('click', () => {
        const card = rail.querySelector('.jf-pcard');
        if (!card) return;
        rail.scrollBy({
          left: (dir === 'prev' ? -1 : 1) * (card.offsetWidth + 16),
          behavior: reduceMotion ? 'auto' : 'smooth',
        });
      });
    };

    root.querySelectorAll('[data-jf-rail-prev]').forEach((b) => hookRail(b, 'prev'));
    root.querySelectorAll('[data-jf-rail-next]').forEach((b) => hookRail(b, 'next'));

    rails.forEach((btns, rail) => {
      const update = () => {
        const max = rail.scrollWidth - rail.clientWidth - 2;
        if (btns.prev) btns.prev.disabled = rail.scrollLeft <= 2;
        if (btns.next) btns.next.disabled = rail.scrollLeft >= max;
      };
      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  }

  function initSection(root) {
    if (root.matches('[data-jf-departments]')) initDepartments(root);
    if (root.matches('[data-jf-showcase]')) initShowcase(root);
    if (root.matches('[data-jf-collections]')) initRails(root);
  }

  function init() {
    document.querySelectorAll('[data-jf-departments], [data-jf-showcase], [data-jf-collections]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const el = e.target.querySelector('[data-jf-departments], [data-jf-showcase], [data-jf-collections]');
    if (el) initSection(el);
  });
})();
